import PopoverAnchor from './PopoverAnchor';

export default PopoverAnchor;
